/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Contract_Purchase_Number_InvalidInputs */

const en_cargo_contract_purchase_number_invalid = /** @type {(inputs: Cargo_Contract_Purchase_Number_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contract purchase number can include letters, numbers, and hyphens`)
};

const es_cargo_contract_purchase_number_invalid = /** @type {(inputs: Cargo_Contract_Purchase_Number_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El numero de compra del contrato puede incluir letras, numeros y guiones`)
};

/**
* | output |
* | --- |
* | "Contract purchase number can include letters, numbers, and hyphens" |
*
* @param {Cargo_Contract_Purchase_Number_InvalidInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_contract_purchase_number_invalid = /** @type {((inputs?: Cargo_Contract_Purchase_Number_InvalidInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Contract_Purchase_Number_InvalidInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_contract_purchase_number_invalid(inputs)
	return es_cargo_contract_purchase_number_invalid(inputs)
});